import PropTypes from 'prop-types';
import { Component } from 'react';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import PortalIdParser from 'PortalIdParser';
import { getRefreshUrl } from 'crm-events-components/internal/helpers/getRefreshUrl';
import { getFullUrl } from 'hubspot-url-utils';
import { View } from 'foundations-components/transitional/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const propTypes = {
  currentUserEmail: PropTypes.string.isRequired,
  portalDomain: PropTypes.string.isRequired,
  useSlimMessage: PropTypes.bool
};
class TimelineRequestElevatedEmailPermissionsCard extends Component {
  getElevatedJITALink() {
    const hubteamUrl = getFullUrl('tools', {
      domainOverride: 'hubteam'
    });
    return `${hubteamUrl}/login/jita?jitaType=ELEVATED&email=${encodeURIComponent(this.props.currentUserEmail)}&jitaDuration=60&loginPortalId=${encodeURIComponent(
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message
    PortalIdParser.get())}&loginPortalName=${encodeURIComponent(this.props.portalDomain)}&loginRedirectUrl=${encodeURIComponent(getRefreshUrl())}`;
  }
  renderJITAButton() {
    return /*#__PURE__*/_jsx(Button, {
      use: "tertiary-light",
      href: this.getElevatedJITALink(),
      size: "sm",
      responsive: false,
      marginBlockStart: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "emailJITAPermissionsCard.requestElevatedAccessButton"
      })
    });
  }
  renderSlimMessage() {
    return /*#__PURE__*/_jsxs("div", {
      "data-unit-test": "slim-message",
      children: [/*#__PURE__*/_jsx("h5", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "emailJITAPermissionsCard.deepLinkTitle"
        })
      }), /*#__PURE__*/_jsx(View, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "emailJITAPermissionsCard.deepLinkDescription"
        })
      }), this.renderJITAButton()]
    });
  }
  renderBody() {
    if (this.props.useSlimMessage) {
      return this.renderSlimMessage();
    }
    return /*#__PURE__*/_jsxs("div", {
      "data-unit-test": "regular-message",
      children: [/*#__PURE__*/_jsx("h5", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "emailJITAPermissionsCard.title"
        })
      }), /*#__PURE__*/_jsx(View, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "emailJITAPermissionsCard.description"
        })
      }), this.renderJITAButton()]
    });
  }
  render() {
    return /*#__PURE__*/_jsxs(Flex, {
      padding: "800",
      justifyContent: "space-around",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Illustration, {
        name: "keys",
        height: 100,
        paddingInlineEnd: "1200"
      }), this.renderBody()]
    });
  }
}
TimelineRequestElevatedEmailPermissionsCard.propTypes = propTypes;
export default TimelineRequestElevatedEmailPermissionsCard;